"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    LoadingSpinner: ()=>LoadingSpinner
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const external_react_namespaceObject = require("react");
const index_cjs_namespaceObject = require("../Spinner/index.cjs");
const external_utils_index_cjs_namespaceObject = require("../../utils/index.cjs");
const external_LoadingSpinner_variants_cjs_namespaceObject = require("./LoadingSpinner.variants.cjs");
const external_use_debounce_namespaceObject = require("use-debounce");
function LoadingSpinner({ className, ...props }) {
    const [show, setShow] = (0, external_use_debounce_namespaceObject.useDebounce)(false, 500);
    const styles = (0, external_LoadingSpinner_variants_cjs_namespaceObject.loadingSpinnerVariants)({
        ...props,
        show: props.loading || show
    });
    const classes = (0, external_utils_index_cjs_namespaceObject.cn)(styles.base(), className);
    const { headerSticky, scrollable } = props;
    const overlayBodyOnly = !scrollable || scrollable && headerSticky;
    const width = 'calc(var(--table-width) * 1px)';
    const height = overlayBodyOnly ? 'calc(var(--table-height) * 1px - var(--table-head-height) * 1px)' : 'calc(var(--table-height) * 1px)';
    const top = overlayBodyOnly ? 'calc(var(--table-head-height) * 1px)' : '0';
    (0, external_react_namespaceObject.useEffect)(()=>{
        setShow(props.loading ?? false);
    }, [
        props.loading,
        setShow
    ]);
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
        className: (0, external_utils_index_cjs_namespaceObject.cn)(classes),
        style: {
            height,
            width,
            top
        },
        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
            className: (0, external_utils_index_cjs_namespaceObject.cn)(styles.wrapper()),
            style: {
                height,
                width
            },
            children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                className: "m-auto flex justify-center",
                "data-testid": "loading-spinner",
                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(index_cjs_namespaceObject.Spinner, {
                    isLoading: props.loading ?? false
                })
            })
        })
    });
}
exports.LoadingSpinner = __webpack_exports__.LoadingSpinner;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "LoadingSpinner"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
